import { useState, useEffect } from 'react';

const useCountdownTimer = (initialTime: number) => {
  const [timeLeft, setTimeLeft] = useState<number>(initialTime);
  const [resendButtonEnabled, setResendButtonEnabled] = useState<boolean>(false);

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setInterval(() => {
        setTimeLeft((prevTime: number) => prevTime - 1);
      }, 1000);

      return () => clearInterval(timerId);
    } else {
        setResendButtonEnabled(true);
    }
  }, [timeLeft]);

  const resetTimer = () => {
    setTimeLeft(initialTime);
    setResendButtonEnabled(false);
  };

  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  return {
    timeLeft: formatTime(timeLeft),
    resendButtonEnabled,
    resetTimer,
  };
};

export default useCountdownTimer;
